import React, { useEffect } from 'react';
import PreviousButton from 'assets/images/previous_button.png';
import NextButton from 'assets/images/next_button.png';
import BackwardButton from 'assets/images/backward_button.png';
import ForwardButton from 'assets/images/forward_button.png';
import EnglishKeyboard from 'components/TimelinePageOne/Keyboard/EnglishKeyboard';
import FarsiKeyboard from 'components/TimelinePageOne/Keyboard/FarsiKeyboard';
import NumberKeyboard from 'components/TimelinePageOne/Keyboard/NumberKeyboard';
import DialPad from 'components/TimelinePageOne/Keyboard/DialPad';
import VolumePlay from 'components/TimelinePageOne/Keyboard/VolumePlay';
import useInputKeys from 'hooks/useInputKeys';
import './index.scss';

function Keyboard() {
    const {
        inputType,
        handleStrInput,
        setCurrentBare,
        nextBare,
        previousBare,
        previousTimeline,
        nextTimeline,
        handleClearStr,
    } = useInputKeys(); 

    useEffect(() => {
        const handleKeyPress = (event) => {
            const { key } = event;
            const isLetter = /^[a-zA-Z]$/.test(key);
            const isNumber = /^[0-9]$/.test(key);
            const isSpecialCharacter = /^[!@#$%^&*()_+\-={};:'"\\|,.<>/?`~[\]]$/.test(key);
            const isBackspace = key === 'Backspace';

            if (isLetter || isNumber || isSpecialCharacter) {
                handleStrInput(key);
            } else if (isBackspace){
                handleClearStr();
            }
        };

        window.addEventListener('keydown', handleKeyPress);
        return () => {
          window.removeEventListener('keydown', handleKeyPress);
        };
      }, [handleStrInput, handleClearStr]);

    return (
        <div className="Keyboard-wrapper">
            <div className="buttons">
                <img src={PreviousButton} alt="Previous Button" onClick={previousTimeline}/>
                <img src={NextButton} alt="Next Button" onClick={nextTimeline}/>
            </div>
            <div className="buttons">
                <img src={BackwardButton} alt="Backward Button" onClick={previousBare} />
                <img src={ForwardButton} alt="Forward Button" onClick={nextBare} />
            </div>
            <div className="bare-keyboards-box">
                <NumberKeyboard setInput={setCurrentBare} />
                {
                    inputType === 'fa' ?
                        <FarsiKeyboard setInput={handleStrInput} />
                        : inputType === 'en' ?
                        <EnglishKeyboard setInput={handleStrInput} /> :
                        true
                }
                <DialPad setInput={handleStrInput} />
                <VolumePlay />
            </div>
        </div>
    );
}

export default Keyboard;
